import { ReactNode, useCallback, useState } from "react";

interface State {
  showOops?: boolean;
  show: boolean;
  message: string;
  actionNode?: ReactNode;
  allowClose?: boolean;
}

const defaultState = {
  showOops: true,
  show: false,
  message: "",
  actionNode: null,
  allowClose: true,
};

const useErrorModalState = () => {
  const [errorModalState, setErrorModalState] = useState<State>(defaultState);

  const hideErrorModal = useCallback(() => {
    setErrorModalState(defaultState);
  }, []);

  return {
    errorModalState,
    setErrorModalState,
    hideErrorModal,
  };
};

export default useErrorModalState;
